import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home-follow.png")